/**
 * Represents the support text field types.
 */
class TextFieldType {
  /**
   * Indicates an email field.
   */
  static email = 'email';

  /**
   * Indicates a password field.
   */
  static password = 'password';

  /**
   * Indicates a phone field
   */
  static phone = 'tel';

  /**
   * Indicates a text field.
   */
  static text = 'text';
}

Object.freeze(TextFieldType);

export default TextFieldType;
